import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyhole2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconKeyhole2"><Path d="M12 2C15.866 2 19 5.13401 19 9C19 11.5125 17.675 13.7129 15.6895 14.9473L17.7119 21.0127C17.7881 21.2414 17.7493 21.4929 17.6084 21.6885C17.4674 21.8841 17.2411 22 17 22H7C6.75892 22 6.53257 21.8841 6.3916 21.6885C6.25065 21.4929 6.21185 21.2414 6.28809 21.0127L8.30957 14.9473C6.32437 13.7129 5 11.5122 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyhole2;
